import React from "react";
import { Section } from "./styles";
const NvidiaContainer = (props) => {
  return <Section>{props.children}</Section>;
};
export default NvidiaContainer;
